export const VIDEO_START_INDEX = 1;

export const THUMBNAIL_SIZES = [85, 140, 110, 110];
